/*
 * @Author: your name
 * @Date: 2022-03-01 14:19:39
 * @LastEditTime: 2022-09-25 21:07:30
 * @LastEditors: zhaoyu zhaoyu@belink.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\clients\controller\system\userModel.ts
 */
import { Regulars } from '@mamba-le/libraries';
import decode from 'jwt-decode';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumLoginWay } from '../../enums';
import { onCreateFactoryAuth } from './auth';
@BindAll()
class UserModel {
  static UserModel: UserModel;
  /**
   * 工厂函数
   * @static
   * @return {*}
   * @memberof UserModel
   */
  static onCreateFactoryUser() {
    if (!lodash.isEmpty(UserModel.UserModel)) {
      return UserModel.UserModel;
    }
    return new UserModel();
  }
  // 单例模式 全局唯一
  constructor() {
    // super();
    // if (!lodash.isEmpty(UserModel.UserModel)) {
    //   return UserModel.UserModel
    // }
    // this.onInit({ type: 'object', storageKey: 'user', storageLoading: false })
    UserModel.UserModel = this;
  }
  /**
   * 认证模块 默认从 cookie 中获取 token 不需要手动设置 token
   * 除非是地址栏解析或者其他方式等等
   * @memberof SystemController
   */
  Auth = onCreateFactoryAuth();
  /**
   * 兼容 之前的 value
   * @readonly
   * @memberof UserModel
   */
  @computed
  get value() {
    return lodash.assign({}, this.Auth.Info);
  }
  /**
   * 兼容 之前的方法
   */
  merge(value) {
    this.Auth.onSaveInfo(lodash.merge({}, this.value, value));
  }
  /**
   * 兼容 之前的方法
   */
  set(value) {
    this.Auth.onSaveInfo(value);
  }

  /** BU */
  @computed
  public get BU() {
    return lodash.get(this.value, 'businessType', '');
  }

  /** 用户分享码 */
  @computed
  public get shareCode() {
    return lodash.get(this.value, 'userId');
  }
  @computed
  public get decodeToken() {
    if (this.Auth.AccessToken) {
      return decode(this.Auth.AccessToken);
    }
    return {};
  }
  /** 身份id */
  @computed
  public get identityId() {
    return (
      lodash.get(this.decodeToken, 'identityId', '') ||
      lodash.get(this.decodeToken, 'identityIds', '')
    );
  }
  @computed
  public get username() {
    return (
      lodash.get(this.decodeToken, 'username', '') ||
      lodash.get(this.value, 'loginUsername', '')
    );
  }
  /** 登录来源 */
  @computed
  public get loginWay() {
    return lodash.get(this.decodeToken, 'loginWay', '');
  }

  /** lenovoid登录 */
  @computed
  public get isLidLogin() {
    return lodash.eq(this.loginWay, EnumLoginWay.LENOVO_LOGIN);
  }
  @computed
  get is12Login() {
    return (
      Regulars.number.test(this.username) && lodash.size(this.username) == 12
    );
  }
  @computed
  public get userId() {
    return lodash.head(
      lodash.compact([
        lodash.get(this.decodeToken, 'sub', ''), //从token解析出userId
        this.username && `username_${this.username}`, //如果没有userId,则取username
      ]),
    );
  }
  /**
 @ 埋点 组合的用户信息
 * UID    => 用户userID
 * BU     => 所属BU(SMB|REL|CON|ISG)
 * ROLE   => 角色（注册商 or 签约商）
 * UT     => 用户类型 UserType
 * SUT    => 用户子类型：SubUserType
 * SIGNED => 是否签约（0 or 1）
 * ISATT  => 是否认证(0 or 1)
 * UL     =>  用户等级 UserLevel(1-4)
 */
  @computed
  public get _la_lenovo_userInfo() {
    //TODO:
    const userIf = lodash.pickBy({ UID: this.userId }, lodash.identity);
    return lodash.join(
      lodash.map(userIf, (value, key) => `${key}:${value}`),
      ';',
    );
  }
}
export const onCreateFactoryUser = UserModel.onCreateFactoryUser;
